// extracted by mini-css-extract-plugin
export var featureItem = "TwinFeatureSection-module--featureItem--6085a";
export var featureText = "TwinFeatureSection-module--featureText--6d082";
export var featureTitle = "TwinFeatureSection-module--featureTitle--d2809";
export var features = "TwinFeatureSection-module--features--78271";
export var imgWrapp = "TwinFeatureSection-module--imgWrapp--19f4a";
export var section = "TwinFeatureSection-module--section--80ec8";
export var swiperContent = "TwinFeatureSection-module--swiperContent--0f4ef";
export var title = "TwinFeatureSection-module--title--fe384";